import { Constantes } from "../config/Contantes";
import { IEntidade } from "../Interfaces/DadosPrevicInterfaces";
import { getEntidadePorCnpj, getTodasEntidades } from "../services/apiCad";
import { keycloakService } from "./keycloakService";

export enum Papel {
  DILIC_MASTER = 'DILIC_MASTER',
  DILIC_USUARIO = 'DILIC_USUARIO',
  DICOL_CGDC = 'DICOL_CGDC',
  DIFIS_CGRE = 'DIFIS_CGRE',
  PREVIC_CONSULTAR = 'PREVIC_CONSULTAR',
  ENTIDADE_ALTERAR = 'ENTIDADE_ALTERAR',
  ENTIDADE_CONSULTAR = 'ENTIDADE_CONSULTAR'
}

const STORED_USERDATA = 'STORED_USERDATA';

interface UserData {
  username :string;
  papel :Papel;
  entidades :IEntidade[];
  entidadesAtivas :IEntidade[];
}

function decodeJWT(token:string) {
  const base64Url = token.split('.')[1];
  const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
  const jsonPayload = decodeURIComponent(
    atob(base64)
      .split('')
      .map(c => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
      .join('')
  );
  return JSON.parse(jsonPayload);
}

export const carregarDadosUsuario = async() => {
    limparLogado();

    if (!keycloakService.token){
      //erro
      throw new Error("Você não está corretamente logado.");
    }
    const claims = decodeJWT(keycloakService.token);
    const username = claims['preferred_username'];
    const grupos:string[] = claims['resource_access'][process.env.REACT_APP_KEYCLOAK_CLIENTID_ROLES!]['roles'];
    //console.log(grupos)

    let papel = undefined;
    let entidades : IEntidade[] = [];
    let entidadesAtivas:IEntidade[] = [];

    if (grupos.length === 0){
      //erro
      throw new Error("Você não tem com nenhum papel no sistema.");
    }
    if (grupos.length === 1 && grupos[0].substring(0, 14) === Constantes.CNPJ_PREVIC){
      if ( grupos[0].endsWith(".cnpj-n1") ){
        papel = Papel.PREVIC_CONSULTAR;
      }
      else if ( grupos[0].endsWith(".cnpj-n2") ){
        papel = Papel.DICOL_CGDC;
      }
      else if ( grupos[0].endsWith(".cnpj-n3") ){
        papel = Papel.DIFIS_CGRE;
      }
      else if ( grupos[0].endsWith(".cnpj-n4") ){
        papel = Papel.DILIC_USUARIO;
      }
      else if ( grupos[0].endsWith(".cnpj-n5") ){
        papel = Papel.DILIC_MASTER;
      }
      entidades = await getTodasEntidades();
      entidadesAtivas = entidades.filter(ent => ent.codSituacaoPrimaria === Constantes.EFPC_SITUACAO_NORMAL);
    }
    else {
      for (const grupo of grupos){
        if (grupo.substring(0, 14) === Constantes.CNPJ_PREVIC){
          throw new Error("Os dados de papéis de usuário estão inválidos. Peça ao suporte para corrigir as permissões no sistema.");
        }
        if (!papel && grupo.endsWith(".cnpj-n1")){
          papel = Papel.ENTIDADE_CONSULTAR;
        }
        else if (grupo.endsWith(".cnpj-n2")){
          papel = Papel.ENTIDADE_ALTERAR;
        }
        if (papel){
          const entidade = await getEntidadePorCnpj( grupo.substring(0, 14) );
          if (entidade){
            entidades.push(entidade);
            if (entidade.codSituacaoPrimaria === Constantes.EFPC_SITUACAO_NORMAL && grupo.endsWith(".cnpj-n2")){
              entidadesAtivas.push(entidade);
            }
          }
        }
      }
    }
    if (!papel || entidades.length === 0){
      //erro
      throw new Error("Não foi possível carregar as entidades do CAD.");
    }

    entidades.sort((a, b) => a.sigla > b.sigla? 1 : a.sigla < b.sigla? -1 : 0);

    const userdata : UserData = {
      username: username,
      papel: papel,
      entidades: entidades,
      entidadesAtivas: entidadesAtivas
    }

    sessionStorage.setItem(STORED_USERDATA, JSON.stringify(userdata));

    //return userdata;
}
export const limparLogado = () => {
  sessionStorage.removeItem(STORED_USERDATA);
}

const getUserData = ():UserData|undefined=>{
  const ud = sessionStorage.getItem(STORED_USERDATA);
  if (!ud)
    return undefined;
  return JSON.parse(ud)
}
export const getUser = (): string => {
  return getUserData()?.username || "";
};
export const getPapel = (): Papel | undefined => {
  return getUserData()?.papel;
};
export const getEntidadesDoUsuarioConsultar = (): IEntidade[] => {
  return getUserData()?.entidades || [];
};
export const getEntidadesAtivas = (): IEntidade[] => {
  return getUserData()?.entidadesAtivas || [];
};
export const getEntidadesLiberadasS3 = (): IEntidade[] => {
  if (hasPermissao([Papel.ENTIDADE_ALTERAR, Papel.ENTIDADE_CONSULTAR])){
    return getEntidadesAtivas().filter(ent => ent.codigoEnquadramento && [3, 4].includes(ent.codigoEnquadramento)) || [];
  }
  return getEntidadesAtivas();
};

export const hasPermissao = (permissoes: Papel[]): boolean => {
  const papel = getPapel();
  if (!papel) return false;
  return permissoes.includes(papel);
};
export const isEntidadeS3ouS4 =  () => {
  const papel = getPapel();
  if (papel === Papel.ENTIDADE_ALTERAR){
    for (let ent of getEntidadesAtivas()){
      if (ent.codigoEnquadramento && [3, 4].includes(ent.codigoEnquadramento)){
        return true;
      }
    }
  }
  return false;
};
